import { CgBlock, CgCheckO, CgDanger } from "react-icons/cg";
import { fail, info, success } from "../theme";

interface ReservationStatus {
  text: string;
  color: string;
  icon?: JSX.Element;
}

export const reservation_status: Record<string, ReservationStatus> = {
  booked: { text: "Reservado", color: success, icon: <CgCheckO size={16} style={{ marginRight: 3 }} /> },
  reserved: { text: "Pré-reserva", color: info, icon: <CgDanger size={16} style={{ marginRight: 3 }} /> },
  contract: { text: "Contrato", color: info, icon: <CgDanger size={16} style={{ marginRight: 3 }} /> },
  blocked: { text: "Bloqueado", color: fail, icon: <CgBlock size={19} style={{ marginRight: 2 }} /> },
  maintenance: { text: "Manutenção", color: info, icon: <CgDanger size={16} style={{ marginRight: 3 }} /> },
  canceled: { text: "Cancelado", color: fail, icon: <CgBlock size={19} style={{ marginRight: 2 }} /> },
};

export const subscription_status: Record<string, { color: string; text: string; icon: JSX.Element }> = {
  "active": {
    color: success,
    text: "Ativo",
    icon: <CgCheckO size={16} style={{ marginRight: 3 }} />
  },
  "paid": {
    color: success,
    text: "Ativo",
    icon: <CgCheckO size={16} style={{ marginRight: 3 }} />
  },
  "paid-free": {
    color: info,
    text: "Teste grátis",
    icon: <CgCheckO size={16} style={{ marginRight: 3 }} />
  },
  "unpaid": {
    color: fail,
    text: "Suspenso",
    icon: <CgBlock size={19} style={{ marginRight: 2 }} />
  },
  "waiting-block": {
    color: info,
    text: "Aguardando pagamento",
    icon: <CgDanger size={16} style={{ marginRight: 3 }} />
  },
  "waiting-alert": {
    color: info,
    text: "Aguardando pagamento",
    icon: <CgDanger size={16} style={{ marginRight: 3 }} />
  },
  "waiting": {
    color: info,
    text: "Aguardando pagamento",
    icon: <CgDanger size={16} style={{ marginRight: 3 }} />
  },
  "expired": {
    color: fail,
    text: "Expirado",
    icon: <CgBlock size={19} style={{ marginRight: 2 }} />
  },
  "canceled": {
    color: fail,
    text: "Cancelado",
    icon: <CgBlock size={19} style={{ marginRight: 2 }} />
  },
  "not-have-transactions": {
    color: info,
    text: "Nenhuma transação",
    icon: <CgDanger size={16} style={{ marginRight: 3 }} />
  },
  "not-have-subscription": {
    color: info,
    text: "Nenhuma assinatura",
    icon: <CgDanger size={16} style={{ marginRight: 3 }} />
  }
};

export const payment_status: any = {
  paid: { text: "Pago", color: success },
  pending: { text: "Pendente", color: info, icon: <CgDanger size={16} style={{ marginRight: 3 }} /> },
  refused: { text: "Recusado", color: fail, icon: <CgBlock size={19} style={{ marginRight: 2 }} /> },
  refunded: { text: "Devolvido", color: fail, icon: <CgBlock size={19} style={{ marginRight: 2 }} /> },
  canceled: { text: "Cancelado", color: fail, icon: <CgBlock size={19} style={{ marginRight: 2 }} /> },
};

export const accommodation_status: any = {
  active: { text: "Ativo", color: success, icon: <CgCheckO size={16} style={{ marginRight: 3 }} /> },
  hidden: { text: "Ativo porém oculto", color: info, icon: <CgDanger size={16} style={{ marginRight: 3 }} /> },
  inactive: { text: "Inativo", color: fail, icon: <CgBlock size={19} style={{ marginRight: 2 }} /> },
  draft: { text: "Rascunho", color: fail, icon: <CgBlock size={19} style={{ marginRight: 2 }} /> },
};

export const notifications_status: any = {
  sent: { text: "Enviado", color: success, icon: <CgCheckO size={16} style={{ marginRight: 3 }} /> },
  pending: { text: "Pendente", color: info, icon: <CgDanger size={16} style={{ marginRight: 3 }} /> },
  failed: { text: "Falhou", color: fail, icon: <CgBlock size={19} style={{ marginRight: 2 }} /> },
  time_exceeded: { text: "Tempo máximo para envio excedido", color: fail, icon: <CgBlock size={19} style={{ marginRight: 2 }} /> },
};
